import { Directive, HostListener, Renderer, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[Select]'
})
export class Select {
  @Input() Select: boolean;
  constructor(public renderer: Renderer, private el: ElementRef) {}

  @HostListener('focus', ['$event'])
  onFocus(event: any) {
    const e = <KeyboardEvent>event;
    if (this.Select) {
      this.el.nativeElement.select();
      this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', '#76FF03');
    } else {
      this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', '');
    }
    // console.log("Focus out called from HostListener");
  }

  @HostListener('focusout', ['$event'])
  onFocusout(event: any) {
    const e = <KeyboardEvent>event;
    if (this.Select) {
      this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', '');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/select.directive.ts